import React, { createContext, useContext, useState, useRef, useCallback } from 'react';

const FloatingVideoContext = createContext();

export const useFloatingVideo = () => {
  const context = useContext(FloatingVideoContext);
  if (!context) {
    throw new Error('useFloatingVideo must be used within FloatingVideoProvider');
  }
  return context;
};

export const FloatingVideoProvider = ({ children }) => {
  const [floatingVideo, setFloatingVideo] = useState(null);
  const videoRef = useRef(null);

  const activateFloatingVideo = useCallback((videoData) => {
    setFloatingVideo(videoData);
  }, []);

  const deactivateFloatingVideo = useCallback(() => {
    setFloatingVideo(null);
  }, []);

  const updateVideoTime = useCallback((currentTime) => {
    setFloatingVideo(prev => {
      if (prev) {
        return { ...prev, currentTime };
      }
      return prev;
    });
  }, []);

  return (
    <FloatingVideoContext.Provider
      value={{
        floatingVideo,
        activateFloatingVideo,
        deactivateFloatingVideo,
        updateVideoTime,
        videoRef
      }}
    >
      {children}
    </FloatingVideoContext.Provider>
  );
};
